import clsx from 'clsx';
import React from 'react';

import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import Label from '@/src/components/common/Elements/Label/Label';
import { parseNumberToStringWithSeparator } from '@/src/util/numbers';
import { getValueWithEllipsis } from '@/src/util/strings';

import { DEFAULT_EMPTY_VALUE } from '../../../Config';
import ActionButton from '../../../Elements/ActionButton/ActionButton';
import ComputationDisplayLayout from '../../../Elements/ComputationDisplayLayout/ComputationDisplayLayout';
import Table from '../../../Elements/Table/Table';
import LineItemsModal from '../../LineItems/LineItemsModal/LineItemsModal';
import Computations from '../../TreatmentForm/Computations/Computations';

const LineItemsListModal = ({
  onClose,
  lineItems,
  containerClassName,
  totals,
  currency,
  taxCalculation,
}) => {
  return (
    <LineItemsModal
      containerClassName={containerClassName}
      modalContentClasses={clsx('tw-flex tw-p-0', 'tw-min-h-[400px] tw-h-full')}
      fileViewerClasses={clsx('tw-h-[calc(100vh-275px)] ')}
    >
      <div className={clsx('tw-p-[20px]', 'tw-w-full')}>
        <Table
          containerClassName={clsx('tw-border-0')}
          headerRowClassName={clsx('tw-border-none tw-pt-[25px]')}
          rowClassName={clsx('last:tw-border-none')}
          data={lineItems}
          columns={[
            {
              title: 'Items',
              field: 'items',
              width: '20%',
              Cell({ entry: { item } }) {
                return <span> {item?.name || DEFAULT_EMPTY_VALUE}</span>;
              },
            },
            {
              title: 'Account',
              field: 'account',
              width: '34%',
              Cell({ entry: { account } }) {
                return (
                  <span> {account ? account.label || account.name : DEFAULT_EMPTY_VALUE}</span>
                );
              },
            },
            {
              title: 'Description',
              width: '27%',
              Cell({ entry: { description } }) {
                return <span> {getValueWithEllipsis(description || DEFAULT_EMPTY_VALUE, 30)}</span>;
              },
            },
            {
              title: 'Tax',
              width: '19%',
              Cell({ entry: { taxCode } }) {
                let label = taxCode.label || taxCode.name;

                if (typeof label === 'object') {
                  label = label.name;
                }

                return <span> {label}</span>;
              },
            },
            {
              title: 'Qty',
              field: 'qty',
              width: '9%',
              Cell({ entry: { qty } }) {
                return <span> {qty || DEFAULT_EMPTY_VALUE}</span>;
              },
            },
            {
              title: 'Unit Price',
              field: 'unitPrice',
              width: '19%',
              Cell({ entry: { unitPrice } }) {
                return <span> {unitPrice || DEFAULT_EMPTY_VALUE}</span>;
              },
            },
            {
              title: 'Amount',
              width: '20%',
              field: 'totalAmount',
              Cell({ entry: { totalAmount } }) {
                return <span> {parseNumberToStringWithSeparator(totalAmount, 2)}</span>;
              },
            },

            {
              title: 'Class',
              field: 'class',
              width: '19%',
              Cell({ entry: { class: itemClass } }) {
                return (
                  <span>
                    {' '}
                    {itemClass ? itemClass.label || itemClass.name : DEFAULT_EMPTY_VALUE}
                  </span>
                );
              },
            },
          ]}
        />
      </div>

      <ComputationDisplayLayout>
        <div className={clsx('tw-w-full', 'tw-flex tw-justify-end')}>
          <ActionButton
            className={clsx('tw-py-[5px] tw-px-0 tw-m-0')}
            buttonType={'style_unset'}
            onClick={onClose}
          >
            <Icon icon={ICONS.close} className={clsx('tw-text-[16px]')} />
          </ActionButton>
        </div>
        <Label
          label={'Amounts are'}
          required={true}
          mainContainerClasses={clsx('tw-mb-[17px]')}
          labelClasses={clsx('tw-text-cfo-black')}
        />
        <span>{taxCalculation}</span>

        <Computations
          totals={totals}
          currency={currency}
          className={clsx('tw-mt-[100px] tw-mb-[30px]')}
        />
      </ComputationDisplayLayout>
    </LineItemsModal>
  );
};

export default LineItemsListModal;
